export function normalizeAeroCode(value) {
  if (typeof value !== "string" || value.length > 24) return null;
  const code = value.toUpperCase().replace(/[\s-]/g, "");
  return /^[BCDFGHJKLMNPQRSTVWXYZ23456789]{8}$/.test(code)
    ? `${code.slice(0, 4)}-${code.slice(4)}`
    : null;
}

// Scanning extracts a pairing code; it never opens the scanned URL.
export function parseAeroQr(value, appOrigin = "https://plkapp.ru") {
  if (typeof value !== "string" || value.length > 2048) return null;
  const code = normalizeAeroCode(value);
  if (code) return code;
  try {
    const url = new URL(value);
    const isAppLink =
      url.protocol === "polka:" && url.hostname === "connect" && !url.pathname;
    const allowedOrigin = new URL(appOrigin).origin;
    const isWebLink =
      ["https:", "http:"].includes(url.protocol) &&
      (url.origin === allowedOrigin ||
        (url.protocol === "https:" &&
          ["plkapp.ru", "www.plkapp.ru"].includes(url.host))) &&
      url.pathname === "/connect";
    if (
      (!isAppLink && !isWebLink) ||
      url.username ||
      url.password ||
      url.searchParams.getAll("user_code").length !== 1
    )
      return null;
    return normalizeAeroCode(url.searchParams.get("user_code"));
  } catch {
    return null;
  }
}
